
import Vue from 'vue';

import * as BLTypes from '@/types/blacklabtypes';

import GlossField from '@/pages/search/form/concept/GlossField.vue';
import { GlossFieldDescription } from '@/store/search/form/glossStore';
import { HitContext, NormalizedAnnotatedField, NormalizedAnnotation, NormalizedMetadataField } from '@/types/apptypes';

import HitContextComponent from '@/pages/search/results/table/HitContext.vue';

export type HitRowData = {
	doc: BLTypes.BLDoc;
	hit: BLTypes.BLHit|BLTypes.BLHitSnippet;
	/** Is the data in this hit from the searched field or from the parallel/related/target field. False if source, true if target. */
	isForeign: boolean;
	context: HitContext;
	/** For parallel corpora. The url to view the hit in the document's version in the target field. */
	href: string;
	/** For parallel corpora. The field in which this version of the hit exists. */
	annotatedField?: NormalizedAnnotatedField;

	// TODO jesse
	gloss_fields: GlossFieldDescription[];
	hit_first_word_id: string; // Jesse
	hit_last_word_id: string // jesse
	hit_id: string; // jesse
}

/**
 * Can contain either a full hit or a partial hit (without capture/relations info)
 * Partials hits are returned when requesting /docs.
 */
export type HitRows = {
	type: 'hit';
	doc: BLTypes.BLDoc;
	rows: HitRowData[];
};

export default Vue.extend({
	components: {
		GlossField,
		HitContextComponent
	},
	props: {
		data: Object as () => HitRowData,
		mainAnnotation: Object as () => NormalizedAnnotation,
		otherAnnotations: Array as () => NormalizedAnnotation[]|undefined,
		metadata: Array as () => NormalizedMetadataField[]|undefined,
		dir: String as () => 'ltr'|'rtl',
		html: Boolean,
		/** Toggles whether we display the source annotated field of the hit. */
		isParallel: Boolean,

		// which match infos (capture/relation) should be highlighted because we're hovering over a token? (parallel corpora)
		hoverMatchInfos: {
			type: Array as () => string[],
			default: () => [],
		},
	},
});
